import { axiosPrivate } from './common/axiosPrivate';
import { getQueryParams, handleResponse, handleError } from '../../helpers/network';

export const list = async ({ page = 1, size = 10, mode = 'user', ...filters }) => {
    const params = getQueryParams({ page, size, mode, ...filters });
    return axiosPrivate.get(`/orders?${params}`).then(handleResponse).catch(handleError);
};

export const get = async (id) => {
    return axiosPrivate.get(`/orders/${id}`).then(handleResponse).catch(handleError);
};

export const create = async ({ user, status, date, items = [] }) => {
    const order = { user, status, date, items };
    return axiosPrivate.post('/orders', order).then(handleResponse).catch(handleError);
};

export const update = async (order) => {
    return axiosPrivate.put(`/orders/${order.id}`, order).then(handleResponse).catch(handleError);
};

export const pay = async (id) => {
    return axiosPrivate.put(`/orders/${id}/pay`).then(handleResponse).catch(handleError);
};

export const close = async (id) => {
    return axiosPrivate.put(`/orders/${id}/close`).then(handleResponse).catch(handleError);
};

export const cancel = async (id) => {
    return axiosPrivate.put(`/orders/${id}/cancel`).then(handleResponse).catch(handleError);
};

export const remove = async (id) => {
    return axiosPrivate.delete(`/orders/${id}`).then(handleResponse).catch(handleError);
};
